import _extends from "@babel/runtime/helpers/extends";
import cx from 'classnames';
import React from 'react';
import { childrenUtils, customPropTypes, getElementType, getUnhandledProps, useKeyOnly } from '../../lib';
import SearchCategoryLayout from './SearchCategoryLayout';

function SearchCategory(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      layoutRenderer = props.layoutRenderer,
      renderer = props.renderer;
  var classes = cx(useKeyOnly(active, 'active'), 'category', className);
  var rest = getUnhandledProps(SearchCategory, props);
  var ElementType = getElementType(SearchCategory, props);
  var categoryContent = renderer(props);
  var resultsContent = childrenUtils.isNil(children) ? content : children;
  return React.createElement(ElementType, _extends({}, rest, {
    className: classes
  }), layoutRenderer({
    categoryContent: categoryContent,
    resultsContent: resultsContent
  }));
}

SearchCategory.handledProps = ["active", "as", "children", "className", "content", "layoutRenderer", "name", "renderer", "results"];
SearchCategory.defaultProps = {
  layoutRenderer: SearchCategoryLayout,
  renderer: function renderer(_ref) {
    var name = _ref.name;
    return name;
  }
};
export default SearchCategory;